import styled from 'styled-components/macro';

import ButtonIcon from 'components/ButtonIcon/ButtonIcon';

export const PriorityIconButtonWrapStyled = styled.div`
  display: inline-block;
  cursor: pointer;
  pointer-events: none;
`;

export const PriorityIconButtonStyled = styled(ButtonIcon)`
  border-radius: 0;
  background: none;
`;
